import { collection, doc, getDoc, getDocs, query, where, orderBy, limit, getCountFromServer } from "firebase/firestore";
import { db } from '../utils/firebase';

// Günlük oyunda geçirilen süre (tek oturumda ve günlük toplam)
export const getDailyGameTime = async (startDate, endDate) => {
  const q = query(
    collection(db, "report_miniGameSessions"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate)
  );
  
  const querySnapshot = await getDocs(q);
  let totalTime = 0;
  let dailyTotals = {};
  let sessionCount = 0;
  
  querySnapshot.forEach((doc) => {
    const data = doc.data().data;
    if (data.miniGameDurations) {
      console.log("data.miniGameDurations",data.miniGameDurations);
      const dailyTime = data.miniGameDurations.reduce((sum, time) => sum + time, 0);
      totalTime += dailyTime;
      
      
      const date = doc.data().timestamp.toDate().toDateString();
      dailyTotals[date] = (dailyTotals[date] || 0) + dailyTime;


      const sessCount = data.miniGameInteractions.reduce((sum, time) => sum + time, 0);
      sessionCount += sessCount;

    }
  });

  console.log("sessionCount",sessionCount);
  
  return {
    totalTime,
    sessionCount,
    averageSessionTime: sessionCount > 0 ? totalTime / sessionCount : 0,
    dailyTotals
  };
};

// Her oyunda ne kadar vakit geçiriliyor
export const getGameTimeByPeriod = async (startDate, endDate) => {
  const q = query(
    collection(db, "report_miniGameSessions"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate)
  );
  
  const querySnapshot = await getDocs(q);
  let gameTimes = {};
  let gameNames = [];
  
  querySnapshot.forEach((doc) => {
    const data = doc.data().data;
    if (data.miniGameDurations && data.miniGameNames) {
      if (gameNames.length === 0) {
        gameNames = data.miniGameNames;
      }
      
      data.miniGameDurations.forEach((time, index) => {
        const gameName = data.miniGameNames[index];
        gameTimes[gameName] = (gameTimes[gameName] || 0) + time;
      });
    }
  });
  
  return { gameTimes, gameNames };
};

// Her oyun toplamda kaç kere oynanıyor
export const getGamePlayCounts = async (startDate, endDate) => {
  const q = query(
    collection(db, "report_miniGameSessions"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate)
  );
  
  const querySnapshot = await getDocs(q);
  let gameCounts = {};
  let gameNames = [];
  
  querySnapshot.forEach((doc) => {
    const data = doc.data().data;
    if (data.miniGameInteractions && data.miniGameNames) {
      if (gameNames.length === 0) {
        gameNames = data.miniGameNames;
      }
      
      data.miniGameInteractions.forEach((count, index) => {
        const gameName = data.miniGameNames[index];
        gameCounts[gameName] = (gameCounts[gameName] || 0) + count;
      });
    }
  });
  
  return { gameCounts, gameNames };
};

// Yeni kıyafet alma oranı ve favori aksesuarlar
export const getClothingStats = async (startDate, endDate) => {
  const q = query(
    collection(db, "takenItems"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate)
  );
  
  const querySnapshot = await getDocs(q);
  let clothingItems = {};
  let totalItems = 0;
  let clothingCount = 0;
  
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    if (data.itemType === 'clothing' || data.category === 'clothing') {
      clothingCount++;
      const itemName = data.itemName || data.name || 'Unknown';
      clothingItems[itemName] = (clothingItems[itemName] || 0) + 1;
    }
    totalItems++;
  });
  
  const clothingRate = totalItems > 0 ? (clothingCount / totalItems) * 100 : 0;
  
  // Sort by popularity
  const sortedItems = Object.entries(clothingItems)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 10);
  
  return {
    clothingRate,
    totalItems,
    clothingCount,
    favoriteAccessories: sortedItems
  };
};

// Favori oyun sıralaması (Top 3)
export const getTopGames = async (startDate, endDate) => {
  const { gameCounts } = await getGamePlayCounts(startDate, endDate);
  
  const sortedGames = Object.entries(gameCounts)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 3);
  
  return sortedGames;
};

// Bir çocuk ortalama günde kaç kere oyuna girip çıkıyor
export const getDailySessionStats = async (startDate, endDate) => {
  // Ana oturum verilerini al
  const sessionQuery = query(
    collection(db, "userSessions"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate),
    orderBy('timestamp', 'asc')
  );
  
  // Alternatif koleksiyonları da kontrol et
  const alternativeQueries = [
    query(collection(db, "sessions"), where('timestamp', '>=', startDate), where('timestamp', '<', endDate)),
    query(collection(db, "gameSessions"), where('timestamp', '>=', startDate), where('timestamp', '<', endDate)),
    query(collection(db, "playerSessions"), where('timestamp', '>=', startDate), where('timestamp', '<', endDate))
  ];
  
  const [sessionSnapshot, ...alternativeSnapshots] = await Promise.all([
    getDocs(sessionQuery),
    ...alternativeQueries.map(q => getDocs(q).catch(() => ({ docs: [] })))
  ]);
  
  let userSessions = {};
  let totalSessions = 0;
  let uniqueUsers = new Set();
  let sessionDurations = [];
  let dailyStats = {};
  let hourlyDistribution = {};
  
  // Ana oturum verilerini işle
  sessionSnapshot.forEach((doc) => {
    const data = doc.data();
    const userId = data.userId || data.playerId || data.user_id;
    const timestamp = data.timestamp?.toDate ? data.timestamp.toDate() : new Date(data.timestamp);
    const date = timestamp.toDateString();
    const hour = timestamp.getHours();
    
    if (userId) {
      uniqueUsers.add(userId);
      totalSessions++;
      
      // Kullanıcı başına günlük oturum sayısı
      if (!userSessions[userId]) {
        userSessions[userId] = {};
      }
      userSessions[userId][date] = (userSessions[userId][date] || 0) + 1;
      
      // Günlük istatistikler
      if (!dailyStats[date]) {
        dailyStats[date] = { sessions: 0, users: new Set() };
      }
      dailyStats[date].sessions++;
      dailyStats[date].users.add(userId);
      
      // Saatlik dağılım
      hourlyDistribution[hour] = (hourlyDistribution[hour] || 0) + 1;
      
      // Oturum süresi (eğer varsa)
      if (data.duration) {
        sessionDurations.push(data.duration);
      } else if (data.sessionDuration) {
        sessionDurations.push(data.sessionDuration);
      } else if (data.endTime && data.startTime) {
        const start = data.startTime?.toDate ? data.startTime.toDate() : new Date(data.startTime);
        const end = data.endTime?.toDate ? data.endTime.toDate() : new Date(data.endTime);
        sessionDurations.push((end - start) / 1000); // saniye cinsinden
      }
    }
  });
  
  // Alternatif koleksiyonlardan veri topla
  alternativeSnapshots.forEach(snapshot => {
    snapshot.docs.forEach((doc) => {
      const data = doc.data();
      const userId = data.userId || data.playerId || data.user_id;
      const timestamp = data.timestamp?.toDate ? data.timestamp.toDate() : new Date(data.timestamp);
      const date = timestamp.toDateString();
      
      if (userId && !uniqueUsers.has(userId)) {
        uniqueUsers.add(userId);
        totalSessions++;
        
        if (!userSessions[userId]) {
          userSessions[userId] = {};
        }
        userSessions[userId][date] = (userSessions[userId][date] || 0) + 1;
      }
    });
  });
  
  // Hesaplamalar
  const averageSessionsPerUser = uniqueUsers.size > 0 ? totalSessions / uniqueUsers.size : 0;
  
  // Günlük ortalama hesaplama
  const totalDays = Object.keys(dailyStats).length;
  const totalDailySessions = Object.values(dailyStats).reduce((sum, day) => sum + day.sessions, 0);
  const averageSessionsPerDay = totalDays > 0 ? totalDailySessions / totalDays : 0;
  
  // Ortalama oturum süresi
  const averageSessionDuration = sessionDurations.length > 0 ? 
    sessionDurations.reduce((sum, duration) => sum + duration, 0) / sessionDurations.length : 0;
  
  // En aktif saat
  const mostActiveHour = Object.entries(hourlyDistribution)
    .sort(([,a], [,b]) => b - a)[0]?.[0] || 0;
  
  // Günlük aktif kullanıcı sayıları
  const dailyActiveUsers = Object.entries(dailyStats).map(([date, stats]) => ({
    date,
    sessions: stats.sessions,
    users: stats.users.size
  })).sort((a, b) => new Date(a.date) - new Date(b.date));
  
  // Kullanıcı segmentasyonu (oturum sayısına göre)
  const userSegments = {
    light: 0,    // 1-2 oturum/gün
    medium: 0,   // 3-5 oturum/gün
    heavy: 0     // 6+ oturum/gün
  };
  
  Object.values(userSessions).forEach(userDays => {
    const totalUserSessions = Object.values(userDays).reduce((sum, sessions) => sum + sessions, 0);
    const avgSessionsPerDay = totalUserSessions / Object.keys(userDays).length;
    
    if (avgSessionsPerDay <= 2) userSegments.light++;
    else if (avgSessionsPerDay <= 5) userSegments.medium++;
    else userSegments.heavy++;
  });
  
  return {
    averageSessionsPerUser: Math.round(averageSessionsPerUser * 10) / 10,
    averageSessionsPerDay: Math.round(averageSessionsPerDay * 10) / 10,
    totalSessions,
    uniqueUsers: uniqueUsers.size,
    averageSessionDuration: Math.round(averageSessionDuration),
    mostActiveHour: `${mostActiveHour}:00`,
    dailyActiveUsers,
    userSegments,
    hourlyDistribution: Object.entries(hourlyDistribution)
      .sort(([a], [b]) => parseInt(a) - parseInt(b))
      .map(([hour, count]) => ({ hour: `${hour}:00`, count }))
  };
};

// Uygulamayı yeni yükleyenleri terk etme oranı
export const getRetentionStats = async () => {
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
  
  // Yeni kullanıcılar (son 2 hafta içinde kayıt olanlar)
  const newUsersQuery = query(
    collection(db, "players"),
    where('createdAt', '>=', twoWeeksAgo)
  );
  
  const newUsersSnapshot = await getDocs(newUsersQuery);
  const newUsers = newUsersSnapshot.docs.map(doc => doc.id);
  
  // Son 2 hafta içinde aktif olan kullanıcılar
  const activeUsersQuery = query(
    collection(db, "userSessions"),
    where('timestamp', '>=', twoWeeksAgo)
  );
  
  const activeUsersSnapshot = await getDocs(activeUsersQuery);
  const activeUsers = new Set();
  activeUsersSnapshot.forEach(doc => {
    const userId = doc.data().userId || doc.data().playerId;
    if (userId) activeUsers.add(userId);
  });
  
  const retainedUsers = newUsers.filter(userId => activeUsers.has(userId));
  const churnRate = newUsers.length > 0 ? ((newUsers.length - retainedUsers.length) / newUsers.length) * 100 : 0;
  
  return {
    newUsers: newUsers.length,
    retainedUsers: retainedUsers.length,
    churnRate
  };
};

// Kullanıcı ayak izleri (zepline binme gibi)
export const getUserFootprints = async (startDate, endDate) => {
  const q = query(
    collection(db, "userActions"),
    where('timestamp', '>=', startDate),
    where('timestamp', '<', endDate)
  );
  
  const querySnapshot = await getDocs(q);
  let actions = {};
  let totalActions = 0;
  
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const action = data.action || data.event || 'unknown';
    actions[action] = (actions[action] || 0) + 1;
    totalActions++;
  });
  
  return { actions, totalActions };
};

// Haftalık indirme, günlük aktif kullanıcı ve aktif cihaz rakamları
export const getWeeklyStats = async () => {
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  
  // Günlük aktif kullanıcılar
  const dauQuery = query(
    collection(db, "userSessions"),
    where('timestamp', '>=', oneWeekAgo)
  );
  
  const dauSnapshot = await getDocs(dauQuery);
  const dailyActiveUsers = new Set();
  const dailyStats = {};
  
  dauSnapshot.forEach(doc => {
    const data = doc.data();
    const userId = data.userId || data.playerId;
    const date = data.timestamp.toDate().toDateString();
    
    if (userId) {
      dailyActiveUsers.add(userId);
      if (!dailyStats[date]) {
        dailyStats[date] = new Set();
      }
      dailyStats[date].add(userId);
    }
  });
  
  // Aktif cihazlar
  const deviceQuery = query(
    collection(db, "devices"),
    where('lastActive', '>=', oneWeekAgo)
  );
  
  const deviceSnapshot = await getDocs(deviceQuery);
  const activeDevices = deviceSnapshot.size;
  
  // Günlük aktif kullanıcı sayıları
  const dailyActiveCounts = Object.keys(dailyStats).map(date => ({
    date,
    count: dailyStats[date].size
  }));
  
  return {
    weeklyActiveUsers: dailyActiveUsers.size,
    activeDevices,
    dailyActiveCounts,
    averageDAU: dailyActiveCounts.length > 0 ? 
      dailyActiveCounts.reduce((sum, day) => sum + day.count, 0) / dailyActiveCounts.length : 0
  };
};
